<template>
  <div class="aws-sku-descriptions">
    <div class="aws-sku-descriptions-image">
      <el-image :src="displayImage" :preview-src-list="[displayImage]" />
    </div>

    <div class="aws-sku-descriptions-info">
      <div class="descriptions">
        <el-row class="descriptions-row">
          <el-col :span="7" class="descriptions-item">
            <div class="descriptions-label">SkuNo</div>
            <div class="descriptions-content">
              {{ data.amzSkuNo }}
            </div>
          </el-col>
          <el-col :span="6" class="descriptions-item">
            <div class="descriptions-label">Status</div>
            <div class="descriptions-content" style="padding: 8px;">
              <AwsSkuStatus
                :value="data.amzSkuStatus"
                :label="data.v_amzSkuStatus"
              />
            </div>
          </el-col>
          <el-col :span="11" class="descriptions-item">
            <div class="descriptions-label">Last update</div>
            <div class="descriptions-content">
              {{ displayModify }}
            </div>
          </el-col>
        </el-row>

        <el-row class="descriptions-row">
          <el-col :span="13" class="descriptions-item">
            <div class="descriptions-label">中文名称</div>
            <div class="descriptions-content">
              {{ data.goodsName || '' }}
            </div>
          </el-col>
          <el-col :span="11" class="descriptions-item">
            <div class="descriptions-label">英文名称</div>
            <div class="descriptions-content">
              {{ data.goodsNameEn || '' }}
            </div>
          </el-col>
        </el-row>

        <el-row class="descriptions-row">
          <el-col :span="8" class="descriptions-item">
            <div class="descriptions-label">品牌</div>
            <div class="descriptions-content">
              {{ data.brandName }}
            </div>
          </el-col>
          <el-col :span="8" class="descriptions-item">
            <div class="descriptions-label">系列/中文系列</div>
            <div class="descriptions-content">
              {{ displayCollection }}
            </div>
          </el-col>
          <el-col :span="8" class="descriptions-item">
            <div class="descriptions-label">品类</div>
            <div class="descriptions-content">
              {{ data.categoryFullName }}
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import AwsSkuStatus from '../aws-sku-status'
export default {
  components: { AwsSkuStatus },
  props: { data: { type: Object, default: () => {} } },
  data() {
    return {}
  },
  computed: {
    displayImage() {
      const { defaultImageUrl } = this.data
      return (
        this.$osscdn(defaultImageUrl) || '/image/static/img/nopic-square.jpg'
      )
    },
    displayModify() {
      const { modifyByName, modifyDate } = this.data
      return [modifyByName, modifyDate].filter(Boolean).join(' at ')
    },
    displayCollection() {
      const { collectionName, collectionNameCn } = this.data
      return [collectionName, collectionNameCn].filter(Boolean).join(' / ')
    },
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
.aws-sku-descriptions {
  display: flex;
  align-items: stretch;
  flex-direction: row;
  .aws-sku-descriptions-image {
    padding: 10px;
    border: 1px solid #ebeef5;
    border-right: none;
    display: flex;
    align-items: center;
    justify-content: center;
    .el-image {
      width: 100px;
      height: 100px;
    }
  }

  .aws-sku-descriptions-info {
    flex-grow: 1;
  }
}

.descriptions {
  --padding: 10px 12px;

  --border-width: 1px;
  --border-style: solid;
  --border-color: #ebeef5;

  --label-width: 125px;
  --label-bg: #f5f7fa;

  border-width: var(--border-width);
  border-color: var(--border-color);
  border-left-style: var(--border-style);
  border-bottom-style: var(--border-style);

  .descriptions-row {
    display: flex;
    align-items: stretch;
    .descriptions-item {
      display: flex;
      align-items: stretch;
      flex-direction: row;
      .descriptions-label {
        font-size: 14px;
        color: #909399;
        width: var(--label-width);
        min-width: var(--label-width);
        padding: var(--padding);
        border-width: var(--border-width);
        border-color: var(--border-color);
        border-top-style: var(--border-style);
        border-right-style: var(--border-style);
        background-color: var(--label-bg);
      }

      .descriptions-content {
        flex-grow: 1;
        font-size: 14px;
        color: #606266;
        padding: var(--padding);
        border-width: var(--border-width);
        border-color: var(--border-color);
        border-top-style: var(--border-style);
        border-right-style: var(--border-style);
        word-break: break-all;
      }
    }
  }
}
</style>
